import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ACCOUNT_URLS, ROUTE_URLS } from '../app.routes.names';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SHOPIFY_TOKENS } from '../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TranslateModule, CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {

  public lang: string = 'en';
  public isMenuOpen = false;
  private readonly collapseMin = 1140;
  constructor(
    private router: Router
  ) { }

  public topUpRoute = ROUTE_URLS.VOUCHER;
  public accountRoute = ACCOUNT_URLS.BASE + '/' + ACCOUNT_URLS.SUMMARY;
  public portRoute = ROUTE_URLS.PORT;

  ngOnInit(): void {
   
  }
  goHome(): void {
    this.router.navigate([ROUTE_URLS.LANDING]);
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    if (this.isMenuOpen) {
      this.isMenuOpen = false;
    }
  }

  get isAuthenticated(): boolean {
    return !!sessionStorage.getItem('auth_token');
  }

  clearAccountStorage(): void {
    sessionStorage.removeItem('expiredAccountBanner');
  }
  goToStore(): void {
    const shopifyAddressesUrl = `https://${SHOPIFY_TOKENS.domain}`;
    window.location.href = shopifyAddressesUrl;
  }

  @HostListener('window:resize', ['$event'])
  handleResize(event: UIEvent): void {
    const width = (event.target as Window).innerWidth;
    if (width >= this.collapseMin && this.isMenuOpen) {
      this.isMenuOpen = false;
    }
  }
}
